<template>
  <div
    class="headerNew"
    :class="{
      headerNewAdmin: role.id == 1 || role.id == 2 || role.id == 3,
      headerNewUser: role.id == 0 || role.id == 5,
    }"
  >
    <!-- <span style="color:red;">当前角色：{{this.$store.state.user.role}}</span> -->
    <div
      class="logo"
      :style="logoUrl ? { backgroundImage: 'url(' + logoUrl + ')' } : ''"
      @click="$router.push('/home')"
    ></div>
    <div class="menu">
      <!-- <div v-for="(item,index) in route" :key="item.title" class="menu-box"> -->
      <div v-for="item in route" :key="item.title" class="menu-box">
        <router-link :to="item.path" class="menu-link" active-class="active">
          <!-- iconfont menu-icon -->
          <!-- <i class="icon-base" :class="item.iconnew"></i> -->
          <i class="iconfont" :class="item.iconnew"></i>
          <span class="menu-title">{{ item.title }}</span>
        </router-link>
        <!-- 菜单间的| -->
        <!-- <div class="line" v-if="!(index == route.length-1)" ></div> -->
      </div>
    </div>
    <!-- 新旧版切换按钮 -->
    <!-- v-if="role.id==0" -->
    <!-- <div class="version-newbox">
      <button type="button" @click="changeMode" v-if="isNewEdition" class="version-btn">
        <i class="iconfont icon-fanhuijiuban"></i>
        {{$t('version.to_old')}}
      </button>
      <button type="button" @click="changeMode" v-else class="version-btn">
        <i class="iconfont icon-fanhuijiuban"></i>
        {{$t('version.to_new')}}
      </button>
    </div>-->
    <!-- 新旧版切换按钮 -->
    <!-- dark light切换按钮 -->
    <!-- <el-switch v-model="themeValue" active-color="#13ce66" inactive-color="#DCDFE6" @change="switchChange">
    </el-switch> -->
    <!-- 主题字体颜色切换 -->
    <div
      v-if="
        !judgePathName &&
        $store.state.user.uidExtra != 57791 &&
        !$store.state.user.riyueyuanPermissionMark
      "
    >
      <div
        class="tool nodeChange"
        v-if="role.id == 1 || role.id == 2 || role.id == 3"
      >
        <el-dropdown
          trigger="click"
          @command="changeTheme"
          @visible-change="changeThemeValue"
        >
          <span class="dropdown-trigger">
            <span style="margin-right: 10px">{{ nowTheme }}</span>
            <i v-if="this.serverThemeValue" class="el-icon-arrow-up"></i>
            <i v-else class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown">
            <el-dropdown-item
              v-for="item in serverThemeList"
              style="align-items: center; display: flex; padding: 3px 15px"
              :command="item.key"
              :key="item.key"
              >{{ item.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 服务器节点切换 -->
    <!-- 需求：普通业主开放国内外节点 -->
    <div
      class="tool nodeChange"
      v-if="role.id == 1 || role.id == 2 || role.id == 3 || role.id == 15"
    >
      <el-dropdown
        trigger="click"
        @command="changeNode"
        @visible-change="changeNodeValue"
      >
        <span class="dropdown-trigger">
          <span style="margin-right: 10px">{{ nodeActive }}</span>
          <i v-if="this.serverNodeValue" class="el-icon-arrow-up"></i>
          <i v-else class="el-icon-arrow-down"></i>
        </span>
        <!-- :class="{selected: currentLang==item.url}" -->
        <el-dropdown-menu slot="dropdown" class="dropdown">
          <el-dropdown-item
            v-for="item in serverNodeList"
            style="align-items: center; display: flex; padding: 3px 15px"
            :command="item.url"
            :key="item.name"
            >{{ item.name }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="tool">
      <!-- <div v-if="role.id==0" class="toggle" @click="dialogDataloggerVisible=true">+</div> -->
      <el-dropdown
        trigger="click"
        placement="bottom"
        @visible-change="changeAlarmValue"
        v-if="role.id != 15"
      >
        <!-- <div class="dropdown-trigger" v-if="role.group=='general'">
          <div>11</div>
        </div>-->
        <div class="dropdown-trigger">
          <el-badge
            v-if="alarmList1.length > 0"
            :value="alarmList1.length"
            :max="99"
          >
            <i class="ico-alarm" style="width: 20px; height: 20px"></i>
          </el-badge>
          <i v-else style class="ico-alarm"></i>
        </div>

        <!-- <span class="dropdown-trigger" v-if="role.group=='general'">
          <i style="" class="ico-alarm" >
            <div class="xiaoxi">{{1}}</div>
          </i>
        </span>
        <span class="dropdown-trigger" v-else>
          <i style="" class="ico-alarm" ></i>
        </span>-->
        <el-dropdown-menu slot="dropdown" class="dropdown-alarm">
          <!-- v-if="alarmList && alarmList.length > 0" -->
          <template>
            <!-- 消息 -->
            <div v-if="role.group == 'general'">
              <div v-if="alarmList && alarmList.length > 0" class="tip-top">
                {{
                  `${$t("alarm.Alarm_Msg")}
                              (${alarmList.length})`
                }}
              </div>
              <div v-else class="tip-top">{{ `${$t("alarm.Alarm_Msg")}` }}</div>
              <div class="tabNews">
                <div
                  v-for="(item, index) in xiaoxiList"
                  :key="index"
                  style="cursor: pointer"
                  :class="{ tabNews1: index == dynamic }"
                  @click="divChange(item, index)"
                >
                  {{ item.name }}
                </div>
              </div>
              <!-- 系统消息(新手指引) -->
              <el-dropdown-item class="alarm-box" v-if="hideFlag1">
                <div
                  v-if="this.oldVersionShow"
                  class="alarm-item"
                  @click="introTrigger"
                  style="width: 100%"
                >
                  <span class="alarm-top">
                    <span class="alarm-name">{{ $t("intro.new_guide") }}</span>
                    <span class="alarm-time">2021-12-8</span>
                  </span>
                  <span class="alarm-type">{{ $t("intro.sys_msg") }}</span>
                </div>
              </el-dropdown-item>
              <!-- 告警列表 -->
              <div v-if="hideFlag">
                <el-dropdown-item
                  class="alarm-box"
                  style="position: relative"
                  v-if="alarmList1.length >= 1"
                >
                  <div
                    class="alarm-item"
                    v-for="(item, index) in alarmList1"
                    :key="index"
                    @click="goAlarmMsg(item)"
                    :class="{ cur: bgcolor == index }"
                  >
                    <div
                      @mouseenter="changebgcolor(index)"
                      @mouseleave="clearcolor"
                    >
                      <span class="alarm-top">
                        <!-- <span class="alarm-name">{{`${$t('alarm.Alarm_Event')}+":"+(${$t(alarm.warning)})`}}</span> -->
                        <span
                          class="alarm-name"
                          v-if="item.level == 2"
                          style="color: #ff3e3e"
                          >{{ $t("alarm.Alarm_Event") }}:{{
                            $t("alarm.device_Fault")
                          }}</span
                        >
                        <span
                          class="alarm-name"
                          v-else-if="item.level == 1"
                          style="color: #ff3e3e"
                          >{{ $t("alarm.Alarm_Event") }}:{{
                            $t("alarm.device_Error")
                          }}</span
                        >
                        <span class="alarm-name" v-else style="color: #ec9630"
                          >{{ $t("alarm.Alarm_Event") }}:{{
                            $t("alarm.device_Warning")
                          }}</span
                        >
                        <!-- <span class="alarm-name">{{item.alias}}</span> -->
                        <span class="alarm-time">{{ item.gts }}</span>
                      </span>
                      <div class="alarm-type">
                        <div>
                          {{ $t("alarm.Alarm_Message") }}{{ item.alias
                          }}{{ $t("alarm.Alarm_Message1") }}{{ item.desc }}
                          <span class="alarm-typeRight"
                            >[{{ $t("alarm.view") }}]</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  class="alarm-box"
                  style
                  v-if="alarmList1.length == 0"
                >
                  <div class="alarmData">{{ $t("alarm.Alarm_data") }}</div>
                </el-dropdown-item>
              </div>
            </div>
            <div v-else>
              <div v-if="alarmList && alarmList.length > 0" class="tip-top">
                {{
                  `${$t("alarm.Alarm_Msg")}
                              (${alarmList.length})`
                }}
              </div>
              <div v-else class="tip-top">{{ `${$t("alarm.Alarm_Msg")}` }}</div>
              <div class="tabNews">
                <div
                  v-for="(item, index) in xiaoxiList"
                  :key="index"
                  style="cursor: pointer"
                  :class="{ tabNews1: index == dynamic }"
                  @click="divChange(item, index)"
                >
                  {{ item.name }}
                </div>
              </div>
              <!-- 系统消息(新手指引) -->
              <el-dropdown-item class="alarm-box" v-if="hideFlag1">
                <!-- <div class="alarm-item" @click="introTrigger" style="width:100%;">
                  <span class="alarm-top">
                    <span class="alarm-name">{{$t('intro.new_guide')}}</span>
                    <span class="alarm-time">2021-12-8</span>
                  </span>
                  <span class="alarm-type">{{$t('intro.sys_msg')}}</span>
                </div>-->
                <div class="alarmData">{{ $t("alarm.Alarm_data") }}</div>
              </el-dropdown-item>
              <!-- 告警列表 -->
              <div v-if="hideFlag">
                <el-dropdown-item
                  class="alarm-box"
                  style="position: relative"
                  v-if="alarmList1.length >= 1"
                >
                  <div
                    class="alarm-item"
                    v-for="(item, index) in alarmList1"
                    :key="index"
                    @click="goAlarmMsg1(item)"
                    :class="{ cur: bgcolor == index }"
                  >
                    <div
                      @mouseenter="changebgcolor(index)"
                      @mouseleave="clearcolor"
                    >
                      <span class="alarm-top">
                        <!-- <span class="alarm-name">{{`${$t('alarm.Alarm_Event')}+":"+(${$t(alarm.warning)})`}}</span> -->
                        <span
                          class="alarm-name"
                          v-if="item.level == 2"
                          style="color: #ff3e3e"
                          >{{ $t("alarm.Alarm_Event") }}:{{
                            $t("alarm.device_Fault")
                          }}</span
                        >
                        <span
                          class="alarm-name"
                          v-else-if="item.level == 1"
                          style="color: #ff3e3e"
                          >{{ $t("alarm.Alarm_Event") }}:{{
                            $t("alarm.device_Error")
                          }}</span
                        >
                        <span class="alarm-name" v-else style="color: #ec9630"
                          >{{ $t("alarm.Alarm_Event") }}:{{
                            $t("alarm.device_Warning")
                          }}</span
                        >
                        <!-- <span class="alarm-name">{{item.alias}}</span> -->
                        <span class="alarm-time">{{ item.gts }}</span>
                      </span>
                      <div class="alarm-type">
                        <div>
                          {{ item.alias }}{{ $t("alarm.Alarm_Message1")
                          }}{{ item.desc }}
                          <span class="alarm-typeRight"
                            >[{{ $t("alarm.view") }}]</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  class="alarm-box"
                  style
                  v-if="alarmList1.length == 0"
                >
                  <div class="alarmData">{{ $t("alarm.Alarm_data") }}</div>
                </el-dropdown-item>
              </div>
            </div>
          </template>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        trigger="hover"
        @command="changeLang"
        @visible-change="changeLangValue"
        placement="bottom"
      >
        <span class="dropdown-trigger" style="margin-left: 15px">
          <span class="language">
            <!-- <img :src="imgurl" style="width:32px;height:24px;" /> -->
            <img
              :src="langActive.langSrc"
              class="lang-img"
              style="width: 18px; height: 18px; margin-right: 6px"
            />
            <span class="lang-text">{{ langActive.lang }}</span>
          </span>
          <!-- <i v-if="this.changeValue" class="el-icon-arrow-up"></i> -->
          <!-- <i v-else class="el-icon-arrow-down"></i> -->
          <!-- <span class="caret"></span> -->
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdown">
          <el-dropdown-item
            v-for="item in langList"
            style="
              align-items: center;
              justify-content: start;
              display: flex;
              width: 134px;
              font-family: Microsoft YaHei;
              font-size: 14px;
            "
            :command="item.value"
            :key="item.name"
            :class="{ selected: currentLang == item.value }"
          >
            <span>
              <img
                :src="item.imgurl"
                style="width: 16px; height: 16px; float: left; margin: 0 15px"
              />
            </span>
            <span>
              {{ item.name }}
            </span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown
        trigger="click"
        @command="handleUsrCommand"
        @visible-change="changeUsrValue"
      >
        <span class="dropdown-trigger">
          <img v-if="avatar" class="avatar" :src="avatar" alt="avatar" />
          <img
            v-else
            class="avatar"
            src="@/assets/img/avatar.png"
            alt="avatar"
          />
          <!-- <span class="username">{{username || 'Welcome'}}</span> -->
          <!-- <div class="infoclick">
            <span class="usernameclick">{{usernameLenght}}</span>
            <span class="roleclick">{{role.name}}</span>
          </div>-->
          <i v-if="this.changeUsr" class="el-icon-arrow-up"></i>
          <i v-else class="el-icon-arrow-down"></i>
          <!-- <span class="caret"></span> -->
        </span>
        <el-dropdown-menu slot="dropdown" class="dropdown">
          <div class="info-container">
            <img v-if="avatar" class="avatar" :src="avatar" alt="avatar" />
            <img
              v-else
              class="avatar"
              src="@/assets/img/avatar.png"
              alt="avatar"
            />
            <div class="info">
              <span class="username">{{ username }}</span>
              <span
                class="role"
                v-if="
                  role.id == 2 &&
                  $store.state.user.riyueyuanPermissionMark &&
                  $store.state.user.riyueyuanRid == 1
                "
                >{{ $t("account.riyueyuan_SonAdmin") }}</span
              >
              <!-- <span class="role" v-else-if="role.id == 2&&$store.state.user.riyueyuanPermissionMark&&$store.state.user.riyueyuanRid ==2">{{ $t("account.riyueyuan_lineSonAdmin") }}</span> -->
              <span class="role" v-else>{{ role.name }}</span>
            </div>
          </div>

          <!-- 个人信息 -->
          <!-- <i class="iconfont icon-accountSet"></i> -->
          <!-- <el-dropdown-item command="goInfo">
            {{$t('header.personal_infor')}}
          </el-dropdown-item>-->
          <!-- 修改密码 -->
          <!-- <i class="iconfont icon-mima"></i> -->
          <!-- <el-dropdown-item command="goPwd">
            {{$t('header.change_password')}}
          </el-dropdown-item>-->
          <!-- 绑定手机 -->
          <!-- <el-dropdown-item command="goMobile" v-if="this.$lang.currentLang =='zh_CN'">
            {{$t('header.bind_mobile')}}
          </el-dropdown-item>-->
          <!-- 绑定邮箱 -->
          <!-- <el-dropdown-item command="goMobile" v-else>
            {{$t('header.bind_email')}}
          </el-dropdown-item>-->
          <!-- 合并成个人信息 -->
          <el-dropdown-item
            command="goCenter"
            v-if="role.id != 15"
            class="informationBox"
          >
            <div>
              <i class="iconfont icon-a-mingchengyonghushuxingyuanxing3"></i>
              {{ $t("basic.personalCenter") }}
            </div>
          </el-dropdown-item>
          <!-- 国际站商城 -->
          <!-- this.$lang.currentLang != 'zh_CN' &&
              this.oldVersionShow &&
              $store.state.user.uidExtra != 57791 &&
              !$store.state.user.riyueyuanPermissionMark -->
              <!-- 暂时隐藏 -->
          <el-dropdown-item v-if="false" class="informationBox"> 
            <div @click="shoppingMall">
              <i class="iconfont icon-a-mingchenggongchang1"></i>
              {{ $t("header.shopping_mall") }}
            </div>
          </el-dropdown-item>
          <!-- 操作手册 -->
          <el-dropdown-item
            v-if="this.oldVersionShow && role.id != 15"
            class="informationBox"
          >
            <div @click="operatingManual">
              <i class="iconfont icon-btn_drawremark"></i>
              {{ $t("header.operating_manual") }}
            </div>
          </el-dropdown-item>
          <!-- 新旧版切换按钮 -->
          <!-- v-if="role.id==0" -->
          <el-dropdown-item
            v-if="isNewEdition && oldVersionShow && role.id != 15"
            class="informationBox"
          >
            <div @click="changeMode">
              <i class="iconfont icon-fanhuijiuban"></i>
              {{ $t("version.to_old") }}
            </div>
          </el-dropdown-item>
          <el-dropdown-item
            v-else-if="oldVersionShow && role.id != 15"
            class="informationBox"
          >
            <div @click="changeMode">
              <i class="iconfont icon-fanhuijiuban"></i>
              {{ $t("version.to_new") }}
            </div>
          </el-dropdown-item>
          <!-- <el-dropdown-item v-else>
            <div @click="changeMode" >
              <i class="iconfont icon-fanhuijiuban" ></i>
              {{$t('version.to_new')}}
            </div>
          </el-dropdown-item>-->
          <!-- 退出 -->
          <el-dropdown-item class="logout informationBox" command="logout">
            <div>
              <i
                class="iconfont icon-a-mingchengtuichu3"
                style="display: inline-block; transform: rotateY(180deg)"
              ></i>
              {{ $t("header.log_out") }}
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!--创建数采器-->
    <datalogger-dialog
      :visible.sync="dialogDataloggerVisible"
      @submitSuc="handleCreateSuc"
      v-if="dialogDataloggerVisible"
    ></datalogger-dialog>
    <!-- 账号设置弹窗 -->
    <info-dialog
      :class="{ showDialog: showInfoDialog, hideDialog: !showInfoDialog }"
      :title="$t('basic.personalCenter')"
      :visible.sync="showInfoDialog"
      :width="'625px'"
      :height="'325px'"
      class="infoBox"
      noFooter
    >
      <div class="content_info" slot="content">
        <div class="basic-img">
          <upload
            :picSmall.sync="infoForm.photo"
            @update:picSmall="saveAvatar"
          ></upload>
        </div>
        <div class="basic-ipt">
          <div class="columnBox">
            <div>{{ this.$t("basic.User_name1") }}</div>
            <input
              class="infoName"
              type="text"
              :value="infoForm.usr"
              disabled
            />
          </div>
          <div class="columnBox">
            <div>{{ this.$t("basic.Nickname1") }}</div>
            <div class="infoData">
              <p>{{ infoForm.qname }}</p>
              <p
                class="editButton"
                @click="
                  (showNicknameDialog = true),
                    (sendCodeFormNickname.Nickname = infoForm.qname)
                "
                v-if="infoForm.qname"
              >
                {{ this.$t("basic.editNickname") }}
              </p>
              <p
                class="editButton1"
                @click="showNicknameDialog = true"
                v-if="!infoForm.qname"
              >
                {{ this.$t("basic.setNickname") }}
              </p>
            </div>
          </div>
          <div v-if="this.$lang.currentLang == 'zh_CN'" class="columnBox">
            <div>{{ this.$t("basic.Mobile1") }}</div>
            <div class="infoData" v-if="infoForm.mobileAccr == true">
              <p>{{ infoForm.mobile }}</p>
              <p class="editButton" @click="bindMobileAlert()">
                {{ this.$t("basic.editMobile") }}
              </p>
            </div>
            <div class="infoData" v-if="infoForm.mobileAccr == false">
              <p class="editButton1" @click="bindMobileAlert()">
                {{ this.$t("basic.setMobile") }}
              </p>
            </div>
          </div>
          <div class="columnBox">
            <div>{{ this.$t("basic.Email1") }}</div>
            <div class="infoData" v-if="infoForm.emailAccr == true">
              <p>{{ infoForm.email }}</p>
              <p class="editButton" @click="bindEmailAlert()">
                {{ this.$t("basic.editEmail") }}
              </p>
            </div>
            <div class="infoData" v-if="infoForm.emailAccr == false">
              <p class="editButton1" @click="bindEmailAlert()">
                {{ this.$t("basic.setEmail1") }}
              </p>
            </div>
          </div>
          <div class="columnBox">
            <div>{{ this.$t("login.pwd") }}</div>
            <div class="editButton1" @click="PwdOperateDialog()">
              {{ this.$t("header.change_password") }}
            </div>
          </div>
        </div>
      </div>
    </info-dialog>
    <!-- 修改昵称 -->
    <info-dialog
      :class="{
        showDialog: showNicknameDialog,
        hideDialog: !showNicknameDialog,
      }"
      :title="$t('basic.editNickname')"
      :visible.sync="showNicknameDialog"
      :width="'625px'"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <el-form
          :model="sendCodeFormNickname"
          :rules="formNicknameRules"
          ref="sendCodeFormNickname"
          class="mobileoperate grid"
        >
          <el-form-item :label="this.$t('basic.Nickname')" prop="Nickname">
            <el-input
              v-model="sendCodeFormNickname.Nickname"
              minlength="2"
              maxlength="32"
              :placeholder="this.$t('basic.Ple_Nickname')"
            ></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="buttonSaveNew">
              <el-button
                class="button button-solid"
                @click="sendCodeNickname"
                >{{ $t("recharge.confirm") }}</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
    </info-dialog>
    <!-- 绑定手机号码操作 -->
    <info-dialog
      :class="{
        showDialog: showMobileOperateDialog,
        hideDialog: !showMobileOperateDialog,
      }"
      :title="$t('basic.editMobile')"
      :visible.sync="showMobileOperateDialog"
      :width="'625px'"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <el-form
          :model="sendCodeFormMobile"
          :rules="codeFormRulesMobile"
          ref="sendCodeFormMobile"
          class="mobileoperate grid"
        >
          <el-form-item :label="this.$t('basic.Mobile')" prop="mobile">
            <el-input
              v-model="sendCodeFormMobile.mobile"
              :placeholder="this.$t('basic.Ple_phone')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="this.$t('basic.code')"
            prop="smsCode"
            class="codebox"
          >
            <div style="display: flex; justify-content: space-between">
              <el-input
                v-model="sendCodeFormMobile.smsCode"
                :placeholder="this.$t('basic.Ple_code')"
                style="width: 200px"
              ></el-input>
              <button
                type="button"
                class="button button-solid"
                v-if="show"
                @click="getCodeMobile"
                style="
                  height: 38px;
                  line-height: 38px;
                  padding: 0 21px;
                  font-size: 14px;
                  margin-left: 10px;
                "
              >
                {{ $t("basic.Obtain_code") }}
              </button>
              <button
                type="button"
                class="button button-solid"
                style="
                  width: 112px;
                  height: 38px;
                  line-height: 38px;
                  padding: 0 22px;
                  font-size: 14px;
                  margin-left: 10px;
                "
                v-if="!show"
              >
                {{ count }} s
              </button>
            </div>
          </el-form-item>
          <el-form-item label=" ">
            <div class="buttonSaveNew">
              <el-button class="button button-solid" @click="sendCodeMobile">{{
                $t("recharge.confirm")
              }}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </info-dialog>
    <!-- 绑定手机号码成功结果 -->
    <info-dialog
      :title="$t('basic.bindRes')"
      :visible.sync="showMobileSucResultDialog"
      :width="'450px'"
      :class="{
        showDialog: showMobileSucResultDialog,
        hideDialog: !showMobileSucResultDialog,
      }"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresultname">{{ $t("basic.suc_ph") }}</span>
          <span class="showresulttip">{{ $t("basic.After_bindingPh") }}</span>
          <button
            type="button"
            class="button-solid showresultbtn"
            @click="MobileSucResultDialog()"
          >
            {{ $t("basic.finished") }}
          </button>
        </div>
      </div>
    </info-dialog>
    <!-- 绑定手机号码失败结果 -->
    <info-dialog
      :title="$t('basic.bindRes')"
      :visible.sync="showMobileFailResultDialog"
      :width="'450px'"
      :class="{
        showDialog: showMobileFailResultDialog,
        hideDialog: !showMobileFailResultDialog,
      }"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresultname">{{ errorMsgTip }}</span>
          <button
            type="button"
            class="button-solid showresultbtn"
            @click="MobileSucResultDialog()"
          >
            {{ $t("basic.retry") }}
          </button>
        </div>
      </div>
    </info-dialog>
    <!-- 绑定邮箱操作 -->
    <!-- v-if="showMobileOperateDialog"  -->
    <info-dialog
      :class="{ showDialog: showEmailDialog, hideDialog: !showEmailDialog }"
      :title="$t('basic.editEmail')"
      :visible.sync="showEmailDialog"
      :width="'625px'"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <el-form
          :model="sendCodeFormEmail"
          :rules="codeFormRulesEmail"
          ref="sendCodeFormEmail"
          class="mobileoperate grid"
        >
          <el-form-item :label="this.$t('basic.Email2')" prop="email">
            <el-input
              v-model="sendCodeFormEmail.email"
              :placeholder="this.$t('basic.Ple_email')"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="this.$t('basic.code')"
            prop="smsCode"
            class="codebox"
          >
            <div style="display: flex; justify-content: space-between">
              <el-input
                v-model="sendCodeFormEmail.smsCode"
                :placeholder="this.$t('basic.Ple_code')"
                style="width: 200px"
              ></el-input>
              <button
                type="button"
                class="button button-solid"
                v-if="show"
                @click="getCodeEmail"
                style="
                  height: 38px;
                  line-height: 38px;
                  padding: 0 21px;
                  font-size: 14px;
                  margin-left: 10px;
                "
              >
                {{ $t("basic.Obtain_code") }}
              </button>
              <button
                type="button"
                class="button button-solid"
                style="
                  width: 112px;
                  height: 38px;
                  line-height: 38px;
                  padding: 0 22px;
                  font-size: 14px;
                  margin-left: 10px;
                "
                v-if="!show"
              >
                {{ count }} s
              </button>
            </div>
          </el-form-item>
          <el-form-item label=" ">
            <div class="buttonSaveNew">
              <el-button class="button button-solid" @click="sendCodeEmail">{{
                $t("recharge.confirm")
              }}</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </info-dialog>
    <!-- 绑定邮箱成功结果 -->
    <!-- v-if="showEmailSucResultDialog" -->
    <info-dialog
      :title="$t('basic.bindRes')"
      :visible.sync="showEmailSucResultDialog"
      :width="'450px'"
      :class="{
        showDialog: showEmailSucResultDialog,
        hideDialog: !showEmailSucResultDialog,
      }"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresultname">{{ $t("basic.suc_em") }}</span>
          <span class="showresulttip">{{ $t("basic.After_bindingEm") }}</span>
          <button
            type="button"
            class="button-solid showresultbtn"
            @click="EmailSucResultDialog()"
          >
            {{ $t("basic.finished") }}
          </button>
        </div>
      </div>
    </info-dialog>
    <!-- 绑定邮箱失败结果 -->
    <!-- v-if="showEmailFailResultDialog" -->
    <info-dialog
      :title="$t('basic.bindRes')"
      :visible.sync="showEmailFailResultDialog"
      :width="'450px'"
      :class="{
        showDialog: showEmailFailResultDialog,
        hideDialog: !showEmailFailResultDialog,
      }"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresultname">{{ errorMsgTip }}</span>
          <button
            type="button"
            class="button-solid showresultbtn"
            @click="EmailSucResultDialog()"
          >
            {{ $t("basic.retry") }}
          </button>
        </div>
      </div>
    </info-dialog>
    <!-- 修改密码操作 -->
    <info-dialog
      :class="{
        showDialog: showPwdOperateDialog,
        hideDialog: !showPwdOperateDialog,
      }"
      :title="$t('basic.changePwd')"
      :visible.sync="showPwdOperateDialog"
      :width="'625px'"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="forgetPassword">
          <div>
            <div class="useinforformss">
              <el-form
                :model="passwordForm"
                ref="passwordForm"
                :rules="passwordFormRules"
                class="mobileoperate grid"
              >
                <el-form-item
                  prop="pwd"
                  :label="this.$t('password.Current_password')"
                  ref="loginPwd"
                >
                  <el-input
                    v-model.trim="passwordForm.pwd"
                    clearable
                    type="password"
                    :placeholder="$t('password.PLCurrent_password')"
                    class="password"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="newpwd"
                  :label="this.$t('password.New_password')"
                  ref="enterPwd"
                >
                  <el-input
                    type="password"
                    class="password"
                    :placeholder="$t('retrieve.Newloginpassword')"
                    v-model.trim="passwordForm.newpwd"
                    clearable
                  ></el-input>
                </el-form-item>
                <el-form-item
                  prop="confPwd"
                  :required="true"
                  :label="this.$t('password.Config_newpassword')"
                  ref="configPwd"
                >
                  <el-input
                    type="password"
                    class="password"
                    :placeholder="$t('retrieve.Confirmloginpassword')"
                    v-model.trim="passwordForm.confPwd"
                    clearable
                    @keyup.enter.native="changePassword"
                  ></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: right" class="buttonSaveNew">
                <button
                  style="margin-top: 28px"
                  type="primary"
                  class="button button-solid"
                  @click="changePassword"
                >
                  {{ $t("retrieve.confirm") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </info-dialog>
    <!-- 修改密码成功结果 -->
    <info-dialog
      :class="{
        showDialog: showPwdSucResultDialog,
        hideDialog: !showPwdSucResultDialog,
      }"
      :title="$t('basic.changeRes')"
      :visible.sync="showPwdSucResultDialog"
      :width="'450px'"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresultname">{{ $t("basic.changePwdSuc") }}</span>
          <button
            type="button"
            class="button-solid showresultbtn"
            @click="showPwdSucResultDialog = false"
          >
            {{ $t("basic.finished") }}
          </button>
        </div>
      </div>
    </info-dialog>
    <!-- 修改密码失败结果 -->
    <info-dialog
      :class="{
        showDialog: showPwdFailResultDialog,
        hideDialog: !showPwdFailResultDialog,
      }"
      :title="$t('basic.changeRes')"
      :visible.sync="showPwdFailResultDialog"
      :width="'450px'"
      noFooter
    >
      <div class="content_tishi" slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresultname">{{ errorMsgTip }}</span>
          <button
            class="button-solid showresultbtn"
            @click="showPwdFailResultDialog = false"
          >
            {{ $t("basic.retry") }}
          </button>
        </div>
      </div>
    </info-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import filter from "@/assets/js/filter";
import cookie from "@/assets/js/cookie.js";
import dataloggerDialog from "@/components/dialog/datalogger";
// import beebeejump from "@/assets/img/beebeejump/logo-pic.png";
// import tgpro from "@/assets/img/tgpro/logo-pic.png";
import dessmonitorLogo from "@/assets/img/default/logo-pic.png";
import axios from "axios";
import Store from "@/store";
// 解决'_t' of null报错
import { i18n } from "@/i18n";
import infoDialog from "@/components/dialognew/dialog";
import upload from "@/components/uploadnew";
import { setTheme } from "@/theme/theme";
import _ from "lodash";
import config from "@/assets/js/config";
export default {
  props: {
    roleType: {
      default: "admin",
    },
  },
  components: {
    upload,
    dataloggerDialog,
    infoDialog,
  },
  data() {
    return {
      themeValue: true,
      nowTheme: "",
      bgcolor: -1,
      // 弹框提示信息
      errorMsgTip: "",
      //获取验证码
      show: true,
      //显示修改昵称
      showNicknameDialog: false,
      // 显示手机绑定操作
      showMobileOperateDialog: false,
      // 显示绑定手机号码成功结果
      showMobileSucResultDialog: false,
      // 显示绑定手机号码失败结果
      showMobileFailResultDialog: false,
      //显示邮箱绑定操作
      showEmailDialog: false,
      // 显示绑定邮箱成功结果
      showEmailSucResultDialog: false,
      // 显示绑定邮箱失败结果
      showEmailFailResultDialog: false,
      // 显示修改密码操作
      showPwdOperateDialog: false,
      // 显示修改密码成功结果
      showPwdSucResultDialog: false,
      // 显示修改密码失败结果
      showPwdFailResultDialog: false,
      dynamic: 0,
      xiaoxiList: [
        { name: i18n.t("intro.gaa_msg") },
        { name: i18n.t("intro.sys_msg") },
      ],
      // 重置密码
      passwordForm: {
        pwd: "",
        newpwd: "",
        confPwd: "",
      },
      //账号设置
      showInfoDialog: false,
      hideFlag: true,
      hideFlag1: false,
      serverThemeList: [
        { name: i18n.t("version.default_theme"), key: "default" },
        { name: i18n.t("version.custom_theme"), key: "YWY" },
      ],
      serverNodeList: [],
      serverThemeValue: false,
      serverNodeValue: false,
      changeValue: false,
      changeUsr: false,
      imgurl: "",
      isNewEdition: true,
      skinList: Object.keys(this.$filter.skin),
      showSkinList: false, // 显示皮肤列表
      dialogDataloggerVisible: false, // 是否显示创建数采器弹窗
      logoUrl: "",
      // 告警列表
      alarmList1: [],
      alarmList: [],
      //账号信息
      infoForm: {},
      count: "",
      //手机号码
      sendCodeFormMobile: {
        mobile: "",
        smsCode: "",
      },
      sendCodeFormNickname: {
        Nickname: "",
      },
      sendCodeFormEmail: {
        email: "",
        smsCode: "",
      },
      // 昵称校验
      formNicknameRules: {
        Nickname: [
          // {
          //   required: true,
          //   message: this.$t("basic.Ple_Nickname"),
          //   trigger: "blur"
          // },
          {
            min: 2,
            max: 32,
            message: this.$t("basic.Nickname_length_tip"),
            trigger: "blur",
          },
        ],
      },
      //手机校验
      codeFormRulesMobile: {
        mobile: [
          {
            required: true,
            message: this.$t("message.mobile_is_required"),
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("signup.mobileformat1"),
            trigger: "blur",
          },
        ],
        smsCode: [
          {
            required: true,
            message: this.$t("basic.Ple_code"),
          },
        ],
      },
      //邮箱校验
      codeFormRulesEmail: {
        email: [
          {
            required: true,
            message: this.$t("message.email_is_required"),
          },
          {
            pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
            message: this.$t("signup.emailformat"),
            trigger: "blur",
          },
        ],
        smsCode: [
          {
            required: true,
            message: this.$t("basic.Ple_code"),
          },
        ],
      },
      passwordFormRules: {
        // 旧密码
        pwd: [
          {
            required: true,
            message: this.$t("message.pwd_is_required"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 32,
            message: this.$t("message.length6_32"),
            trigger: "blur",
          },
          // [不能含有中文]
          // {
          //   // message: this.$t("message.pwd_is_required"),
          //   validator: validatepwd,
          //   trigger: "blur"
          // },
        ],
        // 新密码
        newpwd: [
          {
            required: true,
            message: this.$t("message.pwd_is_required"),
            trigger: "change",
          },
          {
            min: 6,
            max: 32,
            message: this.$t("message.length6_32"),
            trigger: "blur",
          },
          // [不能含有中文]
          // {
          //   // message: this.$t("message.pwd_is_required"),
          //   validator: validatepwd,
          //   trigger: "blur"
          // },
          // 判断新旧密码是否相同
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$t("message.pwdAgain")));
              } else if (value == this.passwordForm.pwd) {
                callback(new Error(this.$t("message.pwdSame")));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        // 确认密码
        confPwd: [
          // [不能含有中文]
          // {
          //   // message: this.$t("message.pwd_is_required"),
          //   validator: validatepwd,
          //   trigger: "blur"
          // },
          {
            required: true,
            message: this.$t("message.confpwd_is_required"),
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error(this.$t("message.pwdAgain")));
              } else if (value !== this.passwordForm.newpwd) {
                callback(new Error(this.$t("message.pwdNotsame")));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      // 旧版显隐
      oldVersionShow: false,
    };
  },
  watch: {
    infoForm: {
      handler(nval, oval) {
        let defaultsBaseURL =
          config.env == "production"
            ? document.location.protocol + "//img.shinemonitor.com/"
            : document.location.protocol + "//solar.test.eybond.com/";
        if (nval.photo) {
          this.$store.commit("saveUserInfo", {
            // avatar: nval.photo
            avatar: nval.photo.includes("http")
              ? nval.photo
              : defaultsBaseURL + nval.photo,
          });
        }
      },
      deep: true,
    },
    //监听经销商隐藏总览
    // "$route"(to,from){
    //   if (this.role.id==2) {
    //     this.route.splice(0,1)
    //   }
    // }
  },
  computed: {
    ...mapState({
      route: (state) => {
        let result = [];
        // console.log('路由',state.user.route)
        state.user.route.forEach((route) => {
          // console.log(route,"route")
          // 过滤掉alarm 、 project、personalBasic、deviceno =====
          if (
            // general
            route.path != "/generalNew/alarm" &&
            route.path != "/generalNew/alarm/archiveHistory" &&
            route.path != "/generalNew/project" &&
            route.path != "/generalNew/personalBasic" &&
            route.path != "/generalNew/deviceno" &&
            // general-新手指引
            route.path != "/generalNew/generalintro" &&
            // admin
            route.path != "/adminNew/alarm/archiveHistory" &&
            route.path != "/adminNew/project" &&
            route.path != "/adminNew/personalBasic" &&
            // admin-新手指引
            route.path != "/adminNew/adminintro" &&
            // admin-大屏
            route.path != "/adminNew/screen"
          ) {
            if (route.path && route.meta) {
              // console.log(route.path,"111111111")
              // console.log(JSON.parse(sessionStorage.getItem("moduleArr")),"11111111111")
              var list = sessionStorage.getItem("moduleArr")
                ? JSON.parse(sessionStorage.getItem("moduleArr"))
                : [];
              let val = sessionStorage.getItem("disPermissionsLogo")
                ? JSON.parse(sessionStorage.getItem("disPermissionsLogo"))
                : false;
              if (state.user.role == 2 && list.length > 0 && val) {
                // var list = JSON.parse(sessionStorage.getItem("moduleArr"));
                if (
                  route.path == "/adminNew/home" &&
                  list.includes("overview")
                ) {
                  result.push({
                    path: route.path,
                    ...route.meta,
                  });
                } else if (
                  route.path == "/adminNew/device" &&
                  list.includes("device_manag")
                ) {
                  result.push({
                    path: route.path,
                    ...route.meta,
                  });
                } else if (
                  route.path == "/adminNew/account" &&
                  list.includes("account_manag")
                ) {
                  result.push({
                    path: route.path,
                    ...route.meta,
                  });
                } else if (
                  route.path == "/adminNew/alarm" &&
                  list.includes("alarm_manag")
                ) {
                  result.push({
                    path: route.path,
                    ...route.meta,
                  });
                } else if (
                  route.path == "/adminNew/setting" &&
                  list.includes("system_settings")
                ) {
                  result.push({
                    path: route.path,
                    ...route.meta,
                  });
                }
              } else {
                result.push({
                  path: route.path,
                  ...route.meta,
                });
              }
            }
          }
        });
        return result;
      },
      username: (state) => state.user.username,
      avatar: (state) => state.user.avatar,
      emailNew: (state) => state.user.emailNew,
      mobileNew: (state) => state.user.mobileNew,
      role: (state) => {
        return {
          id: state.user.role,
          name: filter.roleNew(state.user.role).name,
          group: filter.roleNew(state.user.role).group,
        };
      },
    }),

    ...mapGetters({
      deviceInfo: "getDeviceInfo",
    }),
    ...mapGetters(["getSkin"]),
    langList() {
      var hostname = window.location.hostname;
      var langList = [];
      //比比赞定制只有英文
      if (hostname == "beebeejump.dessmonitor.com") {
        langList.push(this.$lang.langList[0]);
        return langList;
      } else if (hostname == "lshe.dessmonitor.com") {
        //利星行新增两个语言【德语/意大利语】其他域名下不显示这两种语言
        langList.push(this.$lang.langList[0]);
        langList.push(this.$lang.langList[1]);
        langList.push(this.$lang.langList[2]);
        langList.push(this.$lang.langList[3]);
        langList.push(this.$lang.langList[4]);
        langList.push(this.$lang.langList[5]);
        return langList;
      } else if (hostname == "x-tech.dessmonitor.com") {
        //山东洁源新增两【德语】
        langList.push(this.$lang.langList[0]);
        langList.push(this.$lang.langList[1]);
        langList.push(this.$lang.langList[2]);
        langList.push(this.$lang.langList[4]);
        return langList;
      } else if (hostname == "energon.dessmonitor.com") {
        langList.push(this.$lang.langList[0]);
        langList.push(this.$lang.langList[1]);
        langList.push(this.$lang.langList[2]);
        langList.push(this.$lang.langList[5]);
        langList.push(this.$lang.langList[6]);
        langList.push(this.$lang.langList[7]);
        langList.push(this.$lang.langList[8]);
        return langList;
      } else {
        langList.push(this.$lang.langList[0]);
        langList.push(this.$lang.langList[1]);
        langList.push(this.$lang.langList[2]);
        langList.push(this.$lang.langList[4]);
        langList.push(this.$lang.langList[5]);
        langList.push(this.$lang.langList[9]);
        langList.push(this.$lang.langList[10]);
        langList.push(this.$lang.langList[11]); // 西班牙语
        // langList.push(this.$lang.langList[12]); // 阿拉伯语
        return langList;
      }
    },
    currentLang() {
      return this.$lang.currentLang;
    },
    langActive() {
      var lang;
      var langSrc;
      this.$lang.langList.forEach((element) => {
        if (element.value == this.$lang.currentLang) {
          lang = element.name;
          langSrc = element.imgurl;
        }
      });
      return {
        lang,
        langSrc,
      };
    },
    nodeActive() {
      var node;
      for (let i = 0; i < this.serverNodeList.length; i++) {
        if (this.serverNodeList[i].url == cookie.getCookie("saveCurrentNode")) {
          node = this.serverNodeList[i].name;
          break;
        } else {
          node = this.$t("version.default_node");
        }
      }
      return node;
    },
    usernameLenght() {
      if (this.username) {
        if (this.$lang.currentLang == "zh_CN") {
          if (this.username.length > 6) {
            return this.username.substring(0, 6) + "...";
          } else {
            return this.username;
          }
        } else {
          if (this.username.length > 12) {
            return this.username.substring(0, 12) + "...";
          } else {
            return this.username;
          }
        }
      } else {
        return "Welcome";
      }
    },
    judgePathName() {
      let hostname = window.location.hostname;
      if (hostname.indexOf("poweringev") != -1) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    this.hostName();
    this.determineHost();
    this.getUid()
    if (config.env == "production") {
      this.getServerNode();
    } else {
      this.serverNodeList = [
        {
          name: this.$t("version.default_node"),
          url: "",
        },
      ];
    }
    this.$lang.langList.forEach((item) => {
      if (item.value == this.$lang.currentLang) {
        this.imgurl = item.imgurl;
      }
    });
    // 【关于消息】
    this.getMsgList();
    //账号信息
    this.getInfoData();
    // setInterval 配合 setTimeout
    // window.setInterval(() => {
    //   setTimeout(() => {
    //     this.getMsgList();
    //   }, 0)
    // }, 60000);
    // setTimeout(() => {
    //   this.getMsgList();
    // }, 1000);
    // this.distributorOverviewHide();
  },
  mounted() {
    this.getData();
    this.init(); //初始化主题
    window._MEIQIA("metadata", {
      name: JSON.parse(cookie.getCookie("usr")),
    });
    let language = "";
    switch (this.$lang.currentLang) {
      case "zh_CN":
        language = "cn";
        break;
      case "en_US":
        language = "en";
        break;
      default:
        language = "en";
    }
    window._MEIQIA("language", language);
    window._MEIQIA("init");
    window._MEIQIA("hidePanel");
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    // 仅在头像上传成功后保存，避免账号信息初始化时触发修改。
    saveAvatar(photo) {
      if (!photo) return;
      return this.$request.get("editAccount", { photo });
    },
    getUid() { 
      let params = {
        action: 'queryAccountInfo',
      }
      this.$request.get("queryAccountInfo", params).then(res => {
        if (res.err==0) {
          if (res.dat&&res.dat.uid) {
            this.getVcodes(res.dat.uid)
          }
        }
      })
    },
    getVcodes(val){
      let params = {
        action: 'queryAccountInfo',
        source: '1',
        getVcodes: '1',
        uid: val,
      }
      this.$request.get("queryAccountInfo", params).then(res => {
        if (res.err==0) {
          if (res.dat&&res.dat.vcodes) {
            sessionStorage.setItem('vcodes', JSON.stringify(res.dat.vcodes));
            this.$store.commit("saveVcodes", res.dat.vcodes);
          }
        }
      })
    },
    PwdOperateDialog() {
      this.showPwdOperateDialog = true;
      this.$nextTick(() => {
        this.$refs.passwordForm.resetFields();
      });
    },
    init() {
      let hostname = window.location.hostname;
      if (hostname.indexOf("poweringev") != -1) {
        setTheme("YWY-light");
      } else {
        let theme1 = localStorage.getItem("theme1");
        let theme2 = localStorage.getItem("theme2");
        // 没做光暗之前默认 light 按钮值为true
        this.themeValue = true;
        if (theme2) {
          // this.themeValue = theme1 === 'light' ? true : false
          this.nowTheme = _.find(this.serverThemeList, { key: theme2 }).name;
          let theme = theme2 + "-" + theme1;
          setTheme(theme); // 初始化未默认主题
        } else {
          setTheme("default-light");
          this.nowTheme = _.find(this.serverThemeList, { key: "default" }).name;
        }
      }
    },
    // 标准定制显隐
    hostName() {
      var hostname = window.location.hostname;
      if (
        hostname == "www.dessmonitor.com" ||
        hostname == "ess.test.eybond.com" ||
        hostname == "ess.dev.eybond.com" ||
        hostname == "localhost"
      ) {
        this.oldVersionShow = true;
      } else {
        this.oldVersionShow = false;
      }
    },
    //经销商隐藏总览
    // distributorOverviewHide(){
    //   if (this.role.id==2) {
    //     this.route.splice(0,1)
    //   }
    // },
    changebgcolor(index) {
      // index:鼠标移上的元素的索引值
      this.bgcolor = index;
    },
    //鼠标移出，还原颜色
    clearcolor() {
      this.bgcolor = -1;
    },
    //修改手机成功或失败关闭提示刷新数据
    MobileSucResultDialog() {
      this.showMobileSucResultDialog = false;
      this.showMobileOperateDialog = false;
      this.showMobileFailResultDialog = false;
      this.getInfoData();
    },
    //修改邮箱成功或失败关闭提示刷新数据
    EmailSucResultDialog() {
      this.showEmailSucResultDialog = false;
      this.showEmailDialog = false;
      this.showEmailFailResultDialog = false;
      this.getInfoData();
    },
    // 【绑定邮箱弹窗】
    bindEmailAlert() {
      this.showEmailDialog = true;
      // this.sendCodeFormMobile.mobile='';
      // this.sendCodeFormMobile.smsCode='';
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
      this.$nextTick(() => {
        this.$refs.sendCodeFormEmail.resetFields();
      });
    },
    // 【获取邮箱验证码】
    getCodeEmail() {
      this.$refs.sendCodeFormEmail.validateField(["email"], (errorMessage) => {
        let valid = errorMessage == "" ? true : false;
        if (!valid) return false;
        let param = {
          usr: this.infoForm.usr,
          email: this.sendCodeFormEmail.email,
          msgType: "09",
          channel: "01",
          i18n: this.$lang.currentLang,
          webName: "DessMonitor",
          emailAccr: 1,
          source: 1,
        };
        this.$request.get("bindingEmail", param).then((res) => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.email_code"));
            const TIME_COUNT = 180;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      });
    },
    // 【绑定邮箱】
    sendCodeEmail() {
      this.$refs.sendCodeFormEmail.validate((valid) => {
        if (!valid) return false;
        let param = {
          usr: this.infoForm.usr,
          email: this.sendCodeFormEmail.email,
          smsCode: this.sendCodeFormEmail.smsCode,
          msgType: "09",
          channel: "01",
          i18n: this.$lang.currentLang,
          webName: "DessMonitor",
          emailAccr: 1,
          source: 1,
        };
        this.$request.get("bindingEmailStatus", param).then((res) => {
          if (res.err == 0) {
            // this.$message.success(this.$t("basic.suc_em"));
            // this.showEmailOperateDialog = false;
            this.showEmailSucResultDialog = true;
            this.getData();
          } else {
            // this.showEmailOperateDialog = false;
            this.errorMsgTip = this.$t(`errCode.${res.err}`);
            this.showEmailFailResultDialog = true;
          }
        });
      });
    },
    // getCodeEmail() {
    //   let check = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    //   if (!this.sendCodeFormEmail.email) {
    //     this.$message.error(this.$t("retrieve.mobile_first"));
    //   }else if(!check.test(this.sendCodeFormEmail.email)){
    //     this.$message.error(this.$t("signup.emailformat"));
    //   }else {
    //     console.log(this.sendCodeFormEmail.email,"456654");
    //     let param = {
    //       email: this.sendCodeFormEmail.email,
    //       msgType: 9,
    //       source: 1
    //     };
    //     this.$request.get("sendSmsCode", param).then(res => {
    //       if (res.err == 0) {
    //         this.$message.success(this.$t("basic.mobile_code"));
    //         const TIME_COUNT = 90;
    //         if (!this.timer) {
    //           this.count = TIME_COUNT;
    //           this.show = false;
    //           this.timer = setInterval(() => {
    //             if (this.count > 0 && this.count <= TIME_COUNT) {
    //               this.count--;
    //             } else {
    //               this.show = true;
    //               clearInterval(this.timer);
    //               this.timer = null;
    //             }
    //           }, 1000);
    //         }
    //       }else if(res.err == 524){
    //         this.$message.error(this.$t("basic.code_frequently"));
    //       }else {
    //         this.$message.error(this.$t(`errCode.${res.err}`));
    //       }
    //     });
    //   }
    // },
    // // 【修改密码弹窗】
    // changePasswordAlert(){
    //   this.showPwdOperateDialog=true;
    //   this.$nextTick(()=> {
    //     this.$refs.passwordForm.resetFields();
    //   });
    // },
    // 【修改密码提交】
    changePassword() {
      // console.log("pwd-submit-0");
      this.$refs.passwordForm.validate((valid) => {
        // console.log("pwd-submit-1");
        if (!valid) return false;
        // console.log("pwd-submit-2");
        this.$request
          .changePwd(this.passwordForm.newpwd, this.passwordForm.pwd)
          .then((res) => {
            if (res.err == 0) {
              if (cookie.getCookie("role") == this.$store.state.user.role) {
                this.$message.success(this.$t("password.loginAgain"));
                this.$store.commit("logout");
                this.$router.push("/entry");
              } else {
                this.getData();
                // this.$message.success(this.$t("password.editPwdSuc"));
                this.showPwdOperateDialog = false;
                this.errorMsgTip = this.$t(`errCode.${res.err}`);
                this.showPwdSucResultDialog = true;
                // 清空
                Object.keys(this.passwordForm).forEach(
                  (key) => (this.passwordForm[key] = "")
                );
              }
            } else if (res.err == 17) {
              // this.$message.error(this.$t("message.oldPass_wrong"));
              this.showPwdOperateDialog = false;
              this.errorMsgTip = this.$t("message.oldPass_wrong");
              this.showPwdFailResultDialog = true;
              Object.keys(this.passwordForm).forEach(
                (key) => (this.passwordForm[key] = "")
              );
            } else {
              // this.$message.error(this.$t(`errCode.${res.err}`));
              this.showPwdOperateDialog = false;
              this.errorMsgTip = this.$t(`errCode.${res.err}`);
              this.showPwdFailResultDialog = true;
              Object.keys(this.passwordForm).forEach(
                (key) => (this.passwordForm[key] = "")
              );
            }
          });
      });
    },
    //修改昵称
    sendCodeNickname() {
      this.$refs.sendCodeFormNickname.validate((valid) => {
        if (!valid) return false;
        let param = {
          qname: this.sendCodeFormNickname.Nickname || " ",
        };
        this.$request.get("editAccount", param).then((res) => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.modifySuc"));
            this.showNicknameDialog = false;
            this.getInfoData();
            this.sendCodeFormNickname.Nickname = "";
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      });
    },
    // 【绑定手机】
    sendCodeMobile() {
      this.$refs.sendCodeFormMobile.validate((valid) => {
        if (!valid) return false;
        let param = {
          mobile: this.sendCodeFormMobile.mobile,
          msgType: 0x09,
          smsCode: this.sendCodeFormMobile.smsCode,
        };
        this.$request.get("bindUsrMobile", param).then((res) => {
          if (res.err == 0) {
            // this.$message.success(this.$t("basic.suc_ph"));
            // this.showMobileOperateDialog = false;
            this.showMobileSucResultDialog = true;
            // this.bindMobile = false;
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            // this.showMobileOperateDialog = false;
            this.errorMsgTip = this.$t(`errCode.${res.err}`);
            this.showMobileFailResultDialog = true;
          }
        });
      });
    },
    // 【绑定手机弹窗】
    bindMobileAlert() {
      this.showMobileOperateDialog = true;
      // this.sendCodeFormMobile.mobile='';
      // this.sendCodeFormMobile.smsCode='';
      this.show = true;
      clearInterval(this.timer);
      this.timer = null;
      this.$nextTick(() => {
        this.$refs.sendCodeFormMobile.resetFields();
      });
    },
    // 【获取手机验证码】
    getCodeMobile() {
      let check = /^1[3456789]\d{9}$/;
      if (!this.sendCodeFormMobile.mobile) {
        this.$message.error(this.$t("retrieve.mobile_first"));
      } else if (!check.test(this.sendCodeFormMobile.mobile)) {
        this.$message.error(this.$t("signup.mobileformat1"));
      } else {
        let param = {
          mobile: this.sendCodeFormMobile.mobile,
          msgType: 9,
          source: 1,
        };
        this.$request.get("sendSmsCodeLogin", param).then((res) => {
          if (res.err == 0) {
            this.$message.success(this.$t("basic.mobile_code"));
            const TIME_COUNT = 90;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          } else if (res.err == 524) {
            this.$message.error(this.$t("basic.code_frequently"));
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      }
    },
    //获取数据
    getInfoData() {
      this.$request.get("queryAccountInfo").then((res) => {
        if (res.err === 0) {
          this.infoForm = res.dat;
          if (res.dat.vendor && res.dat.vendor.vcode.includes("08")) {
            this.$store.commit("saveRiyueyuanPermissionMark", true);
          } else if (res.dat.dist && res.dat.dist.vcode.includes("08")) {
            this.$store.commit("saveRiyueyuanPermissionMark", true);
            if (res.dat.rid > 0)
              this.$store.commit("saveRiyueyuanRid", res.dat.rid);
          } else {
            this.$store.commit("saveRiyueyuanPermissionMark", false);
          }

          this.$store.commit("saveUserInfo", {
            username: res.dat.usr,
            avatar: res.dat.photo,
            // 用于控制某些操作按钮显隐
            uidExtra: res.dat.uid,
          });
          this.$store.commit("saveChartStatus", res.dat.chartStatus);
          // if (this.$store.state.user.role == 0) {
          //   this.getSuperior();
          // }
        }
      });
    },
    getData() {
      let param = {
        sn: this.deviceInfo.sn,
        i18n: this.$lang.currentLang,
        // devtype: 2304,
        page: 1,
        pageSize: 100,
        handle: false,
      };
      this.$request.getMicroserDess("/alm/api/auth/web/usr/warnings", param).then((res) => {
        if (res.code == 0) {
          // res.dat.warning.forEach(item=>{
          //   if (item.handle==false) {
          //     this.alarmList1.push(item)
          //   }
          // })
          this.alarmList1 = res.data.items.map((item) => {
            return {
              ...item,
              gts: item.gts
                ? this.$filter.formatDate(new Date(item.gts))
                : item.gts,
            };
          });
        }
      });
    },
    //消息通知切换操作
    divChange(item, index) {
      this.dynamic = index;
      if (index == 0) {
        this.hideFlag = true;
        this.hideFlag1 = false;
      } else {
        this.hideFlag = false;
        this.hideFlag1 = true;
      }
    },
    // 系统消息-新手指引
    introTrigger() {
      this.$router.push({
        path: "/" + this.role.group + "New/" + this.role.group + "intro",
      });
    },
    //判断域名修改logo
    determineHost() {
      // let DomainNameStr = window.document.location.hostname;
      // var DomainNameIMG = new Image()
      var _this = this;
      // let host = window.location.hostname.split(".")[0];
      let domainName = window.location.hostname;
      // let regex=/^[a-zA-Z0-9-]+\.(dessmonitor\.com)$/;
      // if (!regex.test(DomainNameStr)) {
      // DomainNameIMG.src = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/logo.png"
      // DomainNameIMG.onload = function () {
      //   _this.logoUrl = document.location.protocol + "//img.shinemonitor.com/img/custom/cus/"+DomainNameStr.replace(/\./g, '')+"/logo.png"
      // }
      // }else{
      let params = {
        domainName: domainName,
      };
      let action =
        "/hmi/api/hmi/domain/check/shineOrDess/auth/checkDomainPass/" + 2;
      _this.$request
        .getHMI(action, params)
        .then((res) => {
          if (res.code == 0) {
            if (res.data.sysLogo) {
              _this.logoUrl = res.data.sysLogo;
            } else {
              _this.logoUrl = dessmonitorLogo;
            }
          } else {
            _this.logoUrl = dessmonitorLogo;
          }
        })
        .catch((e) => {
          _this.logoUrl = dessmonitorLogo;
        });
      // }
      // axios
      //   .get(document.location.protocol + "//img.shinemonitor.com/file/", {
      //     params: {
      //       action: "queryAllCustInfosByDomainName",
      //       domainName: window.document.location.hostname,
      //       sign: "dessmonitor",
      //       salt: new Date().getTime(),
      //       source: 1
      //     }
      //   })
      //   .then(resp => {
      //     this.logoUrl = resp.dat.logoStr
      //   })
      //   .catch(err => {
      //     //
      //     console.log(err)
      //   })
      // var hostname = window.location.hostname;
      // switch (hostname) {
      //   case "beebeejump.dessmonitor.com":
      //     this.logoUrl = beebeejump;
      //     break;
      //   case "tgpropower.dessmonitor.com":
      //     this.logoUrl = tgpro;
      //     break;
      //   default:
      //     this.logoUrl = dessmonitor;
      //     break;
      // }
    },
    getServerNode() {
      let param = {
        source: 1,
        _app_client_: "web",
        _app_id_: window.location.hostname,
        _app_version_: "1.0.6.3",
        i18n: this.$lang.currentLang,
      };
      this.serverNodeList = [];
      this.$request
        .get("queryDomainList", param)
        .then((res) => {
          if (res.err == 0) {
            if (res.dat.length != 0) {
              res.dat.map((element) => {
                this.serverNodeList.push({
                  name: element.name,
                  url: element.url,
                });
              });
            } else {
              this.serverNodeList = [
                {
                  name: this.$t("version.default_node"),
                  url: "",
                },
              ];
            }
          } else {
            this.serverNodeList = [
              {
                name: this.$t("version.default_node"),
                url: "",
              },
            ];
          }
        })
        .catch(() => {
          this.serverNodeList = [
            {
              name: this.$t("version.default_node"),
              url: "",
            },
          ];
        });
    },
    // 用户信息下拉框点击事件
    handleUsrCommand(command) {
      switch (command) {
        case "goCenter":
          // this.$router.push({
          //   name: this.role.group + "NewPersonalBasic"
          // });
          this.showInfoDialog = true;
          break;
        case "logout":
          this.logout();
          break;
        case "goInfo":
          this.$router.push({
            name: this.role.group + "NewPersonalBasic",
          });
          break;
        case "goPwd":
          this.$router.push({
            name: this.role.group + "NewPersonalBasic",
            query: { tab: "pwd" },
          });
          break;
        case "goMobile":
          this.$router.push({
            name: this.role.group + "NewPersonalBasic",
            query: { tab: "pwd" },
          });
          break;
        default:
          break;
      }
    },
    // 创建数采器成功回调
    handleCreateSuc() {
      // 通知数采器列表更新
      this.$store.state.event.updateDataloggerList = true;
      this.$message.success(this.$t("datalogger.addSuc"));
    },
    // 登出
    logout() {
      this.$store.commit("logout");
      this.$router.push("/entry");
      window._MEIQIA("hidePanel");
      location.reload();
    },
    changeAlarmValue(value) {
      if (value) {
        this.dynamic = 0;
        this.hideFlag = true;
        this.hideFlag1 = false;
      }
    },
    // 切换语言
    changeLang(currentLang) {
      this.$lang.currentLang = currentLang;
    },
    changeLangValue(changeValue) {
      this.changeValue = changeValue;
    },
    changeUsrValue(changeUsr) {
      this.changeUsr = changeUsr;
    },
    // 切换皮肤
    changeSkin(currentSkin) {
      this.$store.commit("saveSkin", currentSkin);
    },
    //获取告警消息列表数据
    getMsgList() {
      let param = {
        // page: 1,
        // pagesize: 10000,
      };
      // this.loadingdevice = true;
      this.$request.get("webEditMsgBox", param).then((res) => {
        if (res.err == 0) {
          // console.log('告警消息列表', res.dat);
          this.alarmList = res.dat;
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.$message.warning(i18n.t(`errCode.${res.err}`));
        }
      });
    },
    // 跳转告警消息
    goAlarmMsg(info) {
      this.alarmList = [];
      // *************
      //跳转告警设备
      this.$store.commit("saveDeviceInfo", {
        pn: info.pn,
        sn: info.sn,
        deviceSn: info.deviceSn || info.sn,
        devcode: info.devcode,
        devaddr: info.devaddr,
        status: 4,
        // 增
        brand: info.brand,
        devalias: info.alias,
        profitToday: info.profitToday,
        profitTotal: info.profitTotal,
        sellProfitToday: info.sellProfitToday,
        sellProfitTotal: info.sellProfitTotal,
        buyProfitToday: info.buyProfitToday,
        buyProfitTotal: info.buyProfitTotal,
        // 增
        collalias: info.calias,
        otaLabel: info.otaLabel,
      });
      // *************
      this.$router.push({
        // path: "/generalNew/home",
        path: `/${this.role.group}New/home`,
        query: {
           devcode: info.devcode,
           pn: info.pn,
           devaddr: info.devaddr,
           sn: info.sn,
           pid: info.pid,
           tab: "alarm",
         },
      });
    },
    goAlarmMsg1(info) {
      this.alarmList = [];
      this.$router.push({
        path: `/${this.role.group}New/alarm`,
        query: {
          val: info.pn,
        },
      });
    },
    // 国际站商城
    shoppingMall() {
      window.open(
        "https://eybond.en.alibaba.com/?spm=a2700.shop_plgr.88.3",
        "_blank"
      );
    },
    // 操作手册
    operatingManual() {
      if (
        Store.state.user.role == 1 ||
        Store.state.user.role == 2 ||
        Store.state.user.role == 3
      ) {
        window.open(
          "https://alidocs.dingtalk.com/i/p/Y7kmbqB6n14WKXLq",
          "_blank"
        );
      }
      if (Store.state.user.role == 0 || Store.state.user.role == 5) {
        window.open(
          "https://alidocs.dingtalk.com/i/p/Y7kmbqga4nYQYXLq",
          "_blank"
        );
      }
    },
    //切换版本
    changeMode() {
      this.isNewEdition = !this.isNewEdition;
      cookie.setCookie("isNewEdition", this.isNewEdition);
      this.$store.commit("saveEditionType", {
        isNewEdition: this.isNewEdition,
      });
      this.$store.commit("saveRoute", "");

      if (
        Store.state.user.role == 1 ||
        Store.state.user.role == 2 ||
        Store.state.user.role == 3
      ) {
        this.$router.push("/admin/home");
      }
      if (Store.state.user.role == 0 || Store.state.user.role == 5) {
        this.$router.push("/general/home");
      }
    },
    //主题切换
    switchChange(val) {
      if (val) {
        localStorage.setItem("theme1", "light"); // 保存主题色到本地
      } else {
        localStorage.setItem("theme1", "dark"); // 保存主题色到本地
      }
      let theme =
        localStorage.getItem("theme2") + "-" + localStorage.getItem("theme1");
      setTheme(theme);
    },
    changeTheme(currentTheme) {
      localStorage.setItem("theme2", currentTheme); // 保存主题色到本地
      this.nowTheme = _.find(this.serverThemeList, { key: currentTheme }).name;
      let theme =
        currentTheme + "-" + (this.themeValue === true ? "light" : "dark");
      setTheme(theme);
      // console.log(theme, this.themeValue)
    },
    changeThemeValue(themeValue) {
      this.serverThemeValue = themeValue;
    },
    //节点切换
    changeNode(currentNode) {
      cookie.setCookie("saveCurrentNode", currentNode);
      // window.location.reload()
      // 节点切换后重新获取经销商的权限和页面菜单初始化跳转
      if (this.$store.state.user.role == 2) {
        sessionStorage.removeItem("moduleArr");
        sessionStorage.removeItem("firstPageArr");
        sessionStorage.removeItem("secPageArr");
        sessionStorage.removeItem("buttonArr");
        sessionStorage.setItem("disPermissionsLogo", false);
        this.$request
          .get("queryAccountInfo")
          .then((res) => {
            if (
              res.err === 0 &&
              res.dat.permission &&
              res.dat.permission.length > 0
            ) {
              var moduleArr = [],
                firstPageArr = [],
                secPageArr = [],
                buttonArr = [];
              res.dat.permission.forEach((item) => {
                if (item.isCheck) moduleArr.push(item.action);
                if (item.buttons) {
                  for (
                    var i = 0, length = item.buttons.length;
                    i < length;
                    i++
                  ) {
                    if (item.buttons[i].isCheck) {
                      buttonArr.push(item.buttons[i].action);
                    }
                  }
                }
                item.first_menus.forEach((firstItem) => {
                  if (firstItem.isCheck) firstPageArr.push(firstItem.action);
                  if (firstItem.buttons) {
                    for (
                      var i = 0, length = firstItem.buttons.length;
                      i < length;
                      i++
                    ) {
                      if (firstItem.buttons[i].isCheck) {
                        buttonArr.push(firstItem.buttons[i].action);
                      }
                    }
                  }
                  firstItem.second_menus.forEach((secItem) => {
                    if (secItem.isCheck) secPageArr.push(secItem.action);
                    if (secItem.buttons) {
                      for (
                        var i = 0, length = secItem.buttons.length;
                        i < length;
                        i++
                      ) {
                        if (secItem.buttons[i].isCheck) {
                          buttonArr.push(secItem.buttons[i].action);
                        }
                      }
                    }
                  });
                });
              });
              sessionStorage.setItem("moduleArr", JSON.stringify(moduleArr));
              sessionStorage.setItem(
                "firstPageArr",
                JSON.stringify(firstPageArr)
              );
              sessionStorage.setItem("secPageArr", JSON.stringify(secPageArr));
              sessionStorage.setItem("buttonArr", JSON.stringify(buttonArr));
              sessionStorage.setItem("disPermissionsLogo", true);

              if (moduleArr.includes("overview")) {
                this.$router.push("/adminNew/home");
              } else if (moduleArr.includes("device_manag")) {
                this.$router.push("/adminNew/device");
              } else if (moduleArr.includes("account_manag")) {
                this.$router.push("/adminNew/account");
              } else if (moduleArr.includes("alarm_manag")) {
                this.$router.push("/adminNew/alarm");
              } else if (moduleArr.includes("system_settings")) {
                this.$router.push("/adminNew/setting");
              }
              setTimeout(() => {
                window.location.reload();
              }, 100);
            } else {
              window.location.reload();
            }
          })
          .catch(() => {
            window.location.reload();
          });
      } else {
        window.location.reload();
      }
    },
    changeNodeValue(nodeValue) {
      this.serverNodeValue = nodeValue;
    },
    // getSuperior() {
    //   let params = {
    //     uid: this.$store.state.user.uidExtra,
    //   };
    //   console.log(params);

    //   this.$request.get("queryAdByUsrUid", params).then((res) => {
    //     console.log(res);
    //   });
    // },
  },
};
</script>
<style lang="less">
@import url("../assets/css/mixin.less");
.forgetPassword {
  .el-input--suffix .el-input__inner {
    height: 45px;
    padding-left: 12px;
  }
}

.headerNew {
  display: flex;
  align-items: center;
  padding-right: 24px;
  box-shadow: 0px 4px 19px rgba(0, 0, 0, 0.3);
  // border-bottom: 1px solid @borderColor;
  // box-shadow: 0 2px 2px @shadowColor;
  // background: #fff;
  // background: @themeBg;
  background: rgb(34, 45, 53);
  z-index: 4;
  height: 64px;

  /deep/ .el-form-item__label {
    color: #ebebeb;
  }

  .buttonSaveNew {
    text-align: right;

    // margin-top: 10px;
    button {
      box-sizing: content-box;
      padding: 8px 11px;
      height: 38px;
      line-height: 38px;
      padding: 0 22px;
      font-size: 14px;
      margin-left: 10px;
    }
  }

  // 手机绑定操作
  .mobileoperate {
    &.grid {
      padding-bottom: 0px;
      grid-row-gap: 28px;
    }

    /deep/.el-input {
      height: 40px;
    }

    /deep/.el-input .el-input__inner {
      height: 40px;
    }

    // 输入验证码
    .codebox {
      /deep/.el-form-item__content {
        display: flex;
        align-items: center;
      }

      /deep/.el-input {
        width: 340px;
      }

      /deep/.el-input .el-input__inner {
        width: 340px;
      }
    }
  }

  .infoBox /deep/ .dialog-content {
    padding: 19px 0 0;
  }

  .content_info {
    display: flex;
    color: #adb9c0;
    font-size: 12px;

    .basic-ipt {
      .columnBox {
        margin-bottom: 10px;

        div {
          padding: 4.5px 0;
        }
      }

      .infoName {
        font-size: 14px;
        background-color: #222d35;
        font-weight: 700;
        color: #adb9c0;
      }

      .editButton1 {
        color: #33ffb6;
        cursor: pointer;
      }

      .editButton1:hover {
        text-decoration: underline;
      }

      .infoData {
        display: flex;

        .editButton {
          color: #33ffb6;
          padding-left: 24px;
          cursor: pointer;
        }

        .editButton:hover {
          text-decoration: underline;
        }
      }
    }
  }

  /deep/ .el-input__inner {
    padding-left: 16px;
  }

  // 显示结果
  .showresultbox {
    display: flex;
    flex-direction: column;
    align-items: center;

    .showsuccess {
      border: 3px solid rgba(37, 255, 174, 1);
      background-color: rgba(19, 195, 156, 1);
      background-image: url(../assets/img/general/Icon_Finished.png);
      background-size: 70px 70px;
    }

    .showfail {
      border: 3px solid rgba(246, 189, 189, 1);
      background: rgba(251, 75, 75, 1);
      background-image: url(../assets/img/general/Icon_Failed.png);
      background-size: 120px 120px;
    }

    .showbase {
      width: 100px;
      height: 100px;
      box-sizing: border-box;
      background-repeat: no-repeat;
      background-position: center;
      border-radius: 50%;
    }

    .showresultname {
      font-weight: bold;
      font-size: 18px;
      line-height: 36px;
      margin-top: 30px;
      color: rgba(255, 255, 255, 1);
    }

    .showresulttip {
      color: rgba(255, 255, 255, 0.7);
      font-size: 14px;
      margin-top: 18px;
    }

    .showresultbtn {
      padding: 6px 12px;
      margin-top: 18px;
      border-radius: 6px;
      background: @primaryTextColor;
      color: rgba(34, 45, 53, 1);
      font-size: 14px;
    }
  }

  .logo {
    width: 264px;
    // height: 48px;
    height: 100%;
    text-align: center;
    background: url("../assets/img/logo-pic.png") no-repeat center / 210px;
    cursor: pointer;
  }

  .menu {
    min-width: 370px;
    flex: 1;
    height: 48px;
    margin-left: 14px;

    // padding: 5px 0 0 25px;
    .menu-box {
      display: inline-block;

      // .line{
      //   display: inline-block;
      //   width: 2px;
      //   height: 30px;
      //   margin-bottom: -10px;
      //   background-color: rgba(255, 255, 255, 0.5)
      // }
      .menu-link {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 48px;
        // line-height: 48px;
        margin: auto 6px;
        // display: inline-block;
        opacity: 0.85;
        // min-width: 132px;
        padding: 0 16px;
        // text-align: center;
        border-radius: 10px;
        // border-right:1px solid #f00;
        .sc(14px, #fff);
        cursor: pointer;

        &:hover {
          // opacity: 0.85;
          // background: linear-gradient(
          //   to bottom,
          //   rgba(255, 255, 255, 0.2),
          //   rgba(255, 255, 255, 0.05),
          //   rgba(255, 255, 255, 0.2)
          // );
          color: @primaryTextColor;
        }

        &.active {
          // background: linear-gradient(
          //   to bottom,
          //   rgba(255, 255, 255, 0.2),
          //   rgba(255, 255, 255, 0.05),
          //   rgba(255, 255, 255, 0.2)
          // );
          // color: #fff;
          font-weight: bold;
          color: @primaryTextColor;
        }

        .menu-icon {
          font-size: 20px;
          margin-right: 8px;
        }
      }
    }
  }

  /deep/.el-badge__content.is-fixed {
    top: 12px;
    right: 22px;
  }

  /deep/.el-badge__content {
    background: #dd6843;
    border: none;
    height: 13px;
    font-size: 12px;
    line-height: 13px;
  }

  .tool {
    display: flex;
    align-items: center;
    height: 64px;
    line-height: 64px;

    .ico-alarm {
      display: block;
      position: relative;
      padding: 22px;
      width: 24px;
      height: 24px;
      // margin-right: 50px;
      background: url(../assets/img/general/Icon_Bells_Small.png);
      background-repeat: no-repeat;
      background-size: 24px 24px;
      background-position: center;

      .xiaoxi {
        width: 20px;
        height: 10px;
        font-size: 12px;
        border-radius: 4px;
        background: #16d09a;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
      }
    }

    .ico-alarm:hover {
      border-radius: 6px;
      background-color: @primaryColorTransparency30;
    }

    .ico-alarm-dot:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 11px;
      right: 13px;
      width: 6px;
      height: 6px;
      border-radius: 3px;
      background: rgba(255, 62, 62, 1);
    }

    .add-boxs {
      display: flex;
      padding: 0 16px;
      // margin:auto 10px;
      // display: inline-block;
      // min-width: 132px;
      height: 48px;
      line-height: 48px;
      // padding: 11px;
      // text-align: center;
      border-radius: 10px;
      background: #fff;
      .sc(16px, #000);
      // color: #000;
      // background: @themeColor;
      // &:hover,
      // &:focus {
      //   background: @hoverColor;
      // }
      // &:active {
      //   background: @activeColor;
      // }
      // .sc(14px, #fff);
      cursor: pointer;

      .iconfont {
        font-size: 20px;
        margin-right: 8px;
      }
    }

    .toggle {
      display: inline-block;
      width: 30px;
      height: 30px;
      font-size: 30px;
      line-height: 30px;
      text-align: center;
      color: @themeColor;
      border-radius: 50%;
      background: #fff;
      cursor: pointer;
    }

    > :not(:first-child) {
      margin-left: 16px;
    }

    .iconfont {
      font-size: 28px;
      cursor: pointer;
    }

    .dropdown-trigger {
      display: flex;
      align-items: center;
      color: #ffffff;

      // font-size: 16px;
      // margin-left: 30px;
      &:hover,
      &:focus {
        // background: @activeColor;
        background: #202d35;
        // padding: 0 10px;
      }

      &:active {
        // background: @activeColor;
        background: #202d35;
        // padding: 0 10px;
      }

      cursor: pointer;

      // .avatar {
      //   border-radius: 15%;
      //   width: 30px;
      //   height: 30px;
      // }
      .avatar {
        width: 44px;
        height: 44px;
        border-radius: 15%;
        margin-right: 16px;
      }

      .username {
        margin: 0 10px;
        .sc(14px, #16d09a);
      }

      .language {
        // margin-right: 8px;
        font-size: 14px;
        align-items: center;
        display: flex;
        padding: 12px 10px;
        border-radius: 6px;
        height: 44px;

        &:hover {
          background: @primaryColorTransparency30;
        }
      }

      .infoclick {
        display: flex;
        flex-direction: column;
        justify-content: center;
        white-space: nowrap;
        margin-right: 20px;

        .usernameclick {
          line-height: initial;
          .sc(14px, #16d09a);
        }

        .roleclick {
          margin-top: 5px;
          line-height: initial;
          .sc(14px, #ffffff);
        }
      }
    }
  }
}

.dropdown {
  overflow: hidden;
  background: #202d35;
  border-radius: 6px;
  border: none;
  // padding-left: 15px;

  .informationBox {
    display: flex;
    width: 100%;
    font-size: 15px;

    div {
      margin-left: 16px;
    }

    i {
      font-size: 17px;
      margin-right: 12px;
    }
  }

  .info-container {
    // width: 200px;
    padding: 12px 14px;
    border-bottom: 1px solid #1e2b33;
    display: flex;

    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 15%;
      margin-right: 10px;
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      white-space: nowrap;

      .username {
        width: 80px;
        overflow: hidden;
        text-overflow: ellipsis;
        .sc(14px, #16d09a);
      }

      .role {
        margin-top: 5px;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        .sc(14px, #ffffff);
      }
    }
  }

  .language-item {
    padding: 3px 15px;

    &.selected {
      color: @themeColor;
    }
  }

  .skin {
    position: relative;
    padding: 0;

    .arrow {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .list {
      position: absolute;
      background: #fff;
      top: -1px;
      right: 100%;
      border: 1px solid @borderColor;
      border-radius: 2px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .item {
        padding: 0 20px;
        line-height: 40px;
        white-space: nowrap;
        border-bottom: 1px solid @borderColor;

        &:hover {
          background: #f2f2f2;
        }

        &.selected {
          color: @themeColor;
        }
      }
    }
  }

  // .logout {
  //   height: 41px;
  //   color: #FB807D;
  //   &:hover {
  //     color: lighten(#FB807D, 5%);
  //   }
  // }
}

//告警消息背景色修改
.dropdown-alarm {
  background: #222d35;
  border: 1px solid #222d35;

  .cur {
    background: #215e53;
  }
}

.el-dropdown-menu .el-dropdown-menu__item {
  line-height: 40px;
  color: #ffffff;
  padding: 0px;
}

.el-dropdown-menu {
  background: #202d35;
  color: #fff;
  border: none;
}

.el-dropdown-menu .el-dropdown-menu__item:hover,
.el-dropdown-menu .el-dropdown-menu__item:focus {
  background: #202d35;
  color: #ffffff;
}

// .el-dropdown-menu .el-dropdown-menu__item:not(:last-child) {
//   border-bottom: 1px solid #1E2B33;
// }
.el-dropdown-menu .el-dropdown-menu__item:not(:last-child) {
  border-bottom: none;
}

.el-dropdown-menu .el-dropdown-menu__item:not(:first-child) {
  border-top: 1px solid #1e2b33;
}

// 头部
.headerNew {
  .nodeChange {
    min-width: 100px;
    padding: 0px 10px;
    margin-right: 16px;
    height: 44px;
    line-height: 44px;
  }
  .menu {
    height: 100%;
    margin-left: 0;

    .menu-box {
      // padding-left: 12px;
      &:first-child {
        padding-left: 12px;
      }
      .menu-link {
        height: 64px;
        margin: 0;
        padding: 0 16px;
        border-radius: 0px;

        i {
          font-size: 22px;
        }

        .menu-title {
          font-family: Microsoft YaHei;
          font-size: 16px;
          color: rgb(235, 235, 235);
          margin-left: 10px;
        }

        &.active {
          // .icon-shouyedianji-new {
          //   background: url(../assets/img/general/Icon_HeaderDevice_Dark.png);
          // }
          // .icon-xitongshezhi-new {
          //   background: url(../assets/img/general/Icon_HeaderSetting_Dark.png);
          // }
          font-weight: normal;

          // background: @primaryColorTransparency30;
          i {
            color: rgb(51, 255, 182);
          }

          .menu-title {
            color: @primaryTextColor;
          }
        }

        &:hover {
          // .icon-shouyedianji-new {
          //   background: url(../assets/img/general/Icon_HeaderDevice_Light.png);
          // }
          // .icon-xitongshezhi-new {
          //   background: url(../assets/img/general/Icon_HeaderSetting_Light.png);
          // }
          font-weight: normal;
          // background: fade(@primaryTextColor, 30%);
          background: @primaryColorTransparency30;

          i {
            color: #ffffff;
          }

          .menu-title {
            color: #ffffff;
          }
        }

        // .icon-shouyedianji-new {
        //   width: 22px;
        //   height: 24px;
        //     background: url(../assets/img/general/Icon_HeaderDevice_Light.png);
        // }
        // .icon-xitongshezhi-new {
        //   width: 24px;
        //   height: 24px;
        //     background: url(../assets/img/general/Icon_HeaderSetting_Light.png);
        // }
        // .icon-base {
        //   margin-right: 10px;
        //   background-size: 100%;
        //   background-position: center;
        //   background-repeat: no-repeat;
        // }
      }
    }
  }
}

// 滚动条
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}
</style>
<style lang="less">
.dropdown-alarm {
  background: #222d35;
  border: none;
  padding: 8px 0px;
  max-height: 400px;
  overflow: auto;

  // 新手指引
  // .introTriggerIf {
  //   padding: 0px 26px;
  //   text-align: left;
  //   border-top: 0.5px solid rgba(198, 209, 221, 0.2);
  // }
  // .introTriggerElse {
  //   width: 100%;
  //   padding-bottom: 20px;
  //   cursor: pointer;
  //   font-size: 14px;
  // }
  .tip-top {
    width: 100%;
    text-align: left;
    padding: 0px 16px;
    height: 40px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
    font-weight: bold;
    font-size: 14px;
    border-bottom: 0.5px solid rgba(198, 209, 221, 0.2);
  }

  .tabNews {
    display: flex;
    justify-content: space-between;
    padding: 10px 5px;
    height: 40px;
    font-size: 12px;

    .tabNews1 {
      color: #222d35;
      background-color: #16d09a;
      pointer-events: none;
    }

    div {
      margin: 0 5px;
      width: 128px;
      color: rgba(255, 255, 255, 0.5);
      text-align: center;
      border-radius: 15px;
      height: 22px;
      line-height: 22px;
      background-color: #222d35;
    }
  }

  .alarm-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: auto;
    font-family: Microsoft YaHei;
    font-size: 14px;

    .alarmData {
      text-align: center;
      color: rgba(255, 255, 255, 0.5);
      font-size: 12px;
      height: 12px;
      line-height: 12px;
      margin: 20px 0 28px;
    }
  }

  .alarm-item {
    width: 294px;
    padding: 10px 16px;

    // box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
    // border-top: 0.5px solid rgba(198, 209, 221, 0.2);
    .alarm-top {
      display: flex;
      justify-content: space-between;
      align-self: center;
      height: 100%;

      .alarm-name {
        font-weight: bold;
        // margin-left: 14px;
        font-size: 14px;
        height: 100%;
        line-height: 18px;
      }

      .alarm-time {
        font-size: 12px;
        color: #ffffff;
        // margin-left: 42px;
        opacity: 0.5;
        line-height: 18px;
        height: 100%;
      }
    }

    .alarm-type {
      line-height: 16px;
      display: flex;
      align-items: center;
      text-align: left;
      margin-top: 6px;
      font-size: 12px;
      color: #ffffff;
      opacity: 0.5;
      height: 32px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      .alarm-typeRight {
        color: #16d09a;
      }
    }
  }

  .alarm-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: rgba(199, 199, 199, 1);
    font-size: 12px;

    .tip-ctx {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 40px;
      border-top: 0.5px solid rgba(198, 209, 221, 0.2);
    }
  }
}

// 加载数据时遮罩
// .el-loading-mask {
//   background-color: rgb(34, 45, 53, .5);
// }
// .el-loading-spinner i {
//   color: @primaryTextColor;
// }

// 新旧版切换
.version-newbox {
  margin-right: 16px;

  .version-btn {
    border: 1px solid rgba(183, 183, 183, 1);
    border-radius: 5px;
    background: transparent;
    color: rgba(183, 183, 183, 1);
    padding: 8px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    i {
      font-size: 24px;
      margin-right: 5px;
    }
  }
}
</style>